import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ADPResourceService } from 'digital-core';

@Component({
  selector: 'pgh-deductible-lookup-results',
  templateUrl: './deductible-lookup-results.component.html',
  styleUrls: ['./deductible-lookup-results.component.scss'],
})
export class DeductibleLookupResultsComponent implements OnInit {
  @Input() lookupResults: any;
  @Output() public newLookupClicked = new EventEmitter<any>();

  currentlyOpenedItemIndex: number;
  isDesktopView: boolean = false;
  faqListItems = [
    { questionKey: 'Deductible_Coverage_Key', answerKey: 'Deductible_Coverage_Answer_Key' },
    { questionKey: 'Deductible_ClaimLimits_Key', answerKey: 'Deductible_ClaimLimits_Answer_Key' },
    { questionKey: 'Deductible_ScreenRepair_Key', answerKey: 'Deductible_ScreenRepair_Answer_Key' },
    { questionKey: 'Deductible_Replacement_Key', answerKey: 'Deductible_Replacement_Answer_Key' },
    { questionKey: 'Deductible_Unrecovered_Fee_Key', answerKey: 'Deductible_Unrecovered_Fee_Answer_Key' },
  ];

  constructor(private resourceService: ADPResourceService) {}

  ngOnInit() {
    // Mock Result Data
    // TODO: Replace this with the real results from the lookup.
    this.lookupResults = {
      deviceName: 'Apple iPhone 13x',
      tier: 'Tier 6',
      protections: [
        { claimType: 'Accidental Damage', fee: 199 },
        { claimType: 'Hardware Service/Mechanical Breakdown', fee: 0 },
        { claimType: 'Screen-only repair and back glass-only repair', fee: 49 },
      ],
      protectionsPlus: [
        { claimType: 'Loss/Theft', fee: 199 },
        { claimType: 'Accidental Damage', fee: 199 },
        { claimType: 'Hardware Service/Mechanical Breakdown', fee: 0 },
        { claimType: 'Screen-only repair and back glass-only repair', fee: 49 },
      ],
    };
  }

  setOpened(itemIndex: number) {
    this.currentlyOpenedItemIndex = itemIndex;
  }

  setClosed(itemIndex: number) {
    if (this.currentlyOpenedItemIndex === itemIndex) {
      this.currentlyOpenedItemIndex = -1;
    }
  }

  handleClick() {
    this.newLookupClicked.emit();
  }

  getResource(title: string) {
    let resourceValue = this.resourceService.getViewResourceObject(title);
    return resourceValue;
  }

  getViewLabel(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }
}
